import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSave = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 2H2.5H8H10.75H10.9571L11.1036 2.14645L13.8536 4.89645L14 5.04289V5.25V8V13.5V14H13.5H2.5H2V13.5V2.5V2ZM3 3V13H4.75L4.75 8.5V8H5.25L10.75 8H11.25L11.25 8.5V13H13V8V5.45711L11.25 3.70711V5.7V6.2H10.75H5.25H4.75V5.7V3H3ZM10.25 13V9L5.75 9L5.75 13H10.25ZM8 3H10.25V5.2H5.75V3H8Z",
		fill: "currentColor"
	})
});
export default SvgSave;
